function hugeify({ board, registerCleanup }) {
  board.classList.add('huge');

  registerCleanup(cleanup);

  function cleanup() {
    board.classList.remove('huge');
  }
}

function minify({ board, registerCleanup }) {
  board.classList.add('mini');

  registerCleanup(cleanup);

  function cleanup() {
    board.classList.remove('mini');
  }
}


export { hugeify, minify };
